import React from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'
import ArticleLink from './ArticleLink'

const Container = styled.div`
margin:20px 0;
direction:rtl;
${
    media.desktop`
    margin:20px 10px;
    `
}
`
const ImageContainer = styled.div`
position:relative;
background-repeat:no-repeat;
background-size:cover;
background-image:url(${props => props.src});
background-position:center;
padding-bottom:80%;

${
    media.desktop`
    padding-bottom:45%;
    `
    }
`
const Title = styled.h3`
font-size:3.3rem;
font-weight:700;
${
    media.desktop`
    font-size:4rem;
    `
    }
`
const InfoContainer = styled.div`
margin:20px 0;
color:${colors.white};
${
    media.desktop`
    flex-basis:85%;
    `
    }
`
const Paragraph = styled.p`
font-size:1.8rem;
text-align:right;
font-weight:100;

${
    media.desktop`
    font-size:2.2rem;
    `
    }
`
const BottomContainer = styled.div`
${
    media.desktop`
    display:flex;
    align-items:center;
    justify-content:space-between;
    >:last-child{
        margin:0 10px 0 0;
    }
    `
    }
`

const CarouselItem = (props) => {
    return (
        <Container>
            <ImageContainer src={props.imageSrc}></ImageContainer>
            <BottomContainer>
                <InfoContainer>
                    <Title>{props.title}</Title>
                    <Paragraph>{props.description}</Paragraph>
                </InfoContainer>
                <ArticleLink articleId={props.articleId} width="80%" />
            </BottomContainer>
        </Container>
    )
}

export default CarouselItem;


// WEBPACK FOOTER //
// ./src/components/CarouselItem.jsx